export default {
  props: ['template', 'stage', 'loading', 'selected'],
  methods: {
    sendSelect() {
      this.$emit('cardSelected', this.template);
    }
  }
};
